export default "<p>base works!</p>\r\n";